module.exports = __webpack_public_path__ + "assets/tenBis-logo-8adb25.svg";